import { render, staticRenderFns } from "./productCenter.vue?vue&type=template&id=2f2c667c&scoped=true&"
import script from "./productCenter.vue?vue&type=script&lang=js&"
export * from "./productCenter.vue?vue&type=script&lang=js&"
import style0 from "./productCenter.vue?vue&type=style&index=0&id=2f2c667c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2c667c",
  null
  
)

export default component.exports